import { createFetchClient, loggerAfterHandler } from "@krainovsd/js-helpers";
import { useUserStore } from "@/entities/user";

const apiClient = createFetchClient({
  client: window.fetch.bind(window),
  afterHandlers: [loggerAfterHandler({ filterStatus: (status) => status >= 400 })],
  beforeHandlers: [
    (e) => {
      const token = useUserStore.getState().token;

      if (token) {
        e.headers = {
          ...e.headers,
          Authorization: `Bearer ${token}`,
        };
      }
    },
  ],
});

export const apiRequest = apiClient.requestWithArrayResponse;
